"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm6.74,8.66,1.85-.76a.5.5,0,1,1,.42.91l0,0-1.85.76a.5.5,0,0,1-.38-.93ZM15,4.87,15.79,3a.5.5,0,0,1,.94.33l0,0L16,5.25A.5.5,0,0,1,15,4.91ZM12,2.14a.5.5,0,0,1,1,0v2a.5.5,0,0,1-1,0Zm-3.82.55A.5.5,0,0,1,8.83,3l.76,1.85a.5.5,0,1,1-.91.42l0,0L7.9,3.41A.56.56,0,0,1,8.18,2.69ZM1.94,11.5a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,0,1h-2A.5.5,0,0,1,1.94,11.5Zm3.32,3.84-1.85.76A.5.5,0,1,1,3,15.19l0,0,1.85-.76a.5.5,0,1,1,.42.91Zm.27-6.07a.5.5,0,0,1-.65.27L3,8.78a.5.5,0,0,1,.38-.93l1.85.76a.5.5,0,0,1,.28.65l0,0ZM4.93,5.63a.5.5,0,0,1,.71-.71L7.05,6.33A.5.5,0,1,1,6.34,7M17,19.45a.5.5,0,0,1-.5.5h-9a.5.5,0,0,1-.5-.5v-2.9A.5.5,0,0,1,7.4,16h9.15a.5.5,0,0,1,.5.5Zm-3.29-8.51a2,2,0,1,1-.71-.71l4.7-4.6a.5.5,0,0,1,.71.71Zm7.59,4.84a.5.5,0,0,1-.65.27l-1.85-.76a.5.5,0,0,1,.33-.94l0,0,1.85.76a.5.5,0,0,1,.28.65l0,0ZM21.5,12h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  }));
};

exports["default"] = _default;